import React from 'react';
import PropTypes from 'prop-types';

export const inputStyleClasses = {
  searchBar: 'search-bar',
  searchBarSmall: 'search-bar_small',
  primary: 'primary'
};

export class Input extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      internalError: ''
    };
  }

  numericInput = value => {
    const {onChange, maxValue, minValue, additionalValidation, allowNegative, digitsAfterDot} = this.props;
    let internalError = '';

    if ((isFinite(value) && (allowNegative || +value >= 0)) || (allowNegative && value === '-')) {
      if (maxValue && value > maxValue) {
        internalError = `Max value is ${maxValue}`;
      } else if (minValue && value < minValue) {
        internalError = `Min value is ${minValue}`;
      } else {
        internalError = internalError || additionalValidation ? additionalValidation(value) : '';
      }

      let stringifiedValue = value.toString();
      const dotIndex = stringifiedValue.indexOf('.');

      if (dotIndex !== -1) {
        const decimalDigitsAmount = stringifiedValue.length - dotIndex - 1;
        if (decimalDigitsAmount > digitsAfterDot) {
          value = stringifiedValue.slice(0, digitsAfterDot - decimalDigitsAmount - (digitsAfterDot === 0 ? 1 : 0));
        }
      }

      onChange(value, internalError);

      this.setState({ internalError: internalError });
    }
  };

  sliceAdditionalDigitsAfterDot = value => {
    const {digitsAfterDot} = this.props;
    let stringifiedValue = value.toString();
    const dotIndex = stringifiedValue.indexOf('.');
    const decimalDigitsAmount = stringifiedValue.length - dotIndex - 1;
    if (dotIndex !== -1 && decimalDigitsAmount > digitsAfterDot) return (+value).toFixed(digitsAfterDot);
    return value;
  };

  stringInput = value => {
    const {onChange, maxLength, additionalValidation} = this.props;
    let internalError = '';

    if (maxLength && maxLength < value.length) {
      internalError = `Max length is ${maxLength} characters`;
    } else {
      internalError = additionalValidation ? additionalValidation(value) : '';
    }

    if (!internalError) {
      onChange(value, internalError);
    }

    this.setState({internalError: internalError});
  };

  onChange = ({target}) => {
    const {isNumeric} = this.props;
    let value = target.value;
    if (!isNumeric) {
      this.stringInput(value);
    } else {
      this.numericInput(value);
    }
  };

  render() {
    const {
      mainWrapperClassName,
      labelClassName,
      subLabelClassName,
      subLabelIconClassName,
      inputClassName,
      inputFieldWrapperClassName,
      errorMessageClassName,
      isNumeric,
      placeholder,
      type,
      value,
      error,
      label,
      subLabel,
      secondarySubLabel,
      onBlur,
      onFocus,
      units,
      capitalizeLabel,
      disabled,
      unitsTop,
      tabIndex,
      styleClass,
      isTextArea,
    } = this.props;
    const { internalError } = this.state;

    let currentError = typeof error === 'string' && error.length ? error : internalError || error;

    //TODO upon next style refactor remove this part and set appropriate styleClass everywhere
    let mainWrapperClasses = '';
    let inputWrapperClasses = '';
    let inputClasses = '';
    let errorTextElementClass = '';
    let textStyles = '';
    let labelClasses = '';
    let subLabelClasses = '';
    let unitsPosition = {};
    if (styleClass) {
      mainWrapperClasses = `input__main-wrapper input__main-wrapper_${styleClass} ${currentError ? 'error' : ''} ${
        units ? 'with-units' : ''
      } ${disabled ? 'disabled' : ''}`;
      inputWrapperClasses = `input__input-field-wrapper input__input-field-wrapper_${styleClass}`;
      inputClasses = `input__input-field input__input-field_${styleClass} ${currentError ? 'error' : ''}`;
      errorTextElementClass = `input__error-message input__error-message_${styleClass}`;
      labelClasses = `input__label input__label_${styleClass}`;
      subLabelClasses = `input__sub-label input__sub-label_${styleClass}`;
    } else {
      mainWrapperClasses = `ect-input ${currentError ? 'error' : ''} ${units ? 'with-units' : ''} ${
        disabled ? 'disabled' : ''
      }`;
      inputWrapperClasses = 'ect-input-wrapper';
      inputClasses = `${currentError ? 'error' : ''} ${units ? 'with-units' : ''} ${disabled ? 'disabled' : ''}`;
      errorTextElementClass = 'input__error-message';
      subLabelClasses = 'input__sub-label';
      textStyles = { textAlign: 'center' };
      if (units) {
        unitsPosition.left = '52%';
        unitsPosition.top = unitsTop;
        textStyles.textAlign = 'right';
        textStyles.paddingRight = '50%';
      }
    }

    const errorTextElement = currentError ? (
      <div className={`${errorTextElementClass} ${errorMessageClassName}`}>{currentError}</div>
    ) : null;
    const updatedLabel = label && capitalizeLabel ? label[0].toUpperCase() + label.slice(1).toLowerCase() : label;

    return (
      <div className={`${mainWrapperClasses} ${mainWrapperClassName}`}>
        <label className={`${labelClasses} ${labelClassName}`}>
          {updatedLabel}
        </label>
        {subLabel && (
          <div className={`${subLabelClasses} ${subLabelClassName}`}>
            {subLabelIconClassName ? <span className={`input__sub-label-icon ${subLabelIconClassName}`} /> : null}
            <span>{subLabel}</span>
          </div>
        )}
        {secondarySubLabel && (
          <div className={`${subLabelClasses} ${subLabelClassName}`}>
            {subLabelIconClassName ? <span className={`input__sub-label-icon ${subLabelIconClassName}`} /> : null}
            <span>{secondarySubLabel}</span>
          </div>
        )}
        <div className={`${inputWrapperClasses} ${inputFieldWrapperClassName}`}>
          {!isTextArea ? (
            <input
              className={inputClasses + ' ' + inputClassName}
              type={type}
              style={{ ...textStyles }}
              placeholder={placeholder}
              value={isNumeric && value ? this.sliceAdditionalDigitsAfterDot(value) : value}
              onBlur={onBlur}
              onFocus={onFocus}
              onChange={this.onChange}
              autoComplete='off'
              tabIndex={tabIndex}
              disabled={disabled ? 'disabled' : ''}
            />
          ) : (
            <textarea
              className={inputClasses + ' ' + inputClassName}
              type={type}
              placeholder={placeholder}
              value={isNumeric && value ? this.sliceAdditionalDigitsAfterDot(value) : value}
              onBlur={onBlur}
              onFocus={onFocus}
              onChange={this.onChange}
              autoComplete='off'
              tabIndex={tabIndex}
              disabled={disabled ? 'disabled' : ''}
            />
          )}
          {errorTextElement}
          {units ? (
            <span className={'units'} style={{ ...unitsPosition, textAlign: 'left' }}>
              {units}
            </span>
          ) : null}
          {this.props.children}
        </div>
      </div>
    );
  }
}

Input.propTypes = {
  mainWrapperClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  subLabelClassName: PropTypes.string,
  subLabelIconClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  inputFieldWrapperClassName: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  styleClass: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  label: PropTypes.string,
  subLabel: PropTypes.string,
  secondarySubLabel: PropTypes.string,
  units: PropTypes.string,
  textAlign: PropTypes.string,
  maxLength: PropTypes.any,
  isNumeric: PropTypes.bool,
  capitalizeLabel: PropTypes.bool,
  digitsAfterDot: PropTypes.number,
  unitsTop: PropTypes.number,
  tabIndex: PropTypes.number,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  isTextArea: PropTypes.bool,
};

Input.defaultProps = {
  mainWrapperClassName: '',
  labelClassName: '',
  subLabelClassName: '',
  subLabelIconClassName: '',
  inputClassName: '',
  inputFieldWrapperClassName: '',
  errorMessageClassName:'',
  placeholder: '',
  type: 'text',
  styleClass: '',
  value: '',
  onChange: () => {},
  onBlur: () => {},
  onFocus: () => {},
  error: '',
  label: '',
  subLabel: '',
  secondarySubLabel: '',
  units: '',
  textAlign: 'center',
  maxLength: null,
  isNumeric: false,
  capitalizeLabel: false,
  digitsAfterDot: 2,
  unitsTop: 25,
  tabIndex: 0,
  isTextArea: false,
};

export class MultiInput extends React.Component {
  static defaultProps = {
    placeholder: '',
    type: 'text',
    value: '',
    onChange: () => {
    },
    onBlur: () => {
    },
    label: '',
    units: '',
    styles: {width: 'inherit', height: 40, paddingLeft: 20},
    textAlign: 'center',
    maxLength: 256,
    numbersOnly: false,
    maxValue: Infinity,
    minValue: -Infinity,
    digitsAfterDot: 2,
  };

  constructor(props) {
    super(props);
    this.state = {
      internalError: ''
    };
  }

  numericInternalValidation = value => {
    const {onChange, digitsAfterDot, maxValue, minValue, additionalValidation, allowNegative} = this.props;
    let internalError = '';

    if ((isFinite(value) && (allowNegative || +value >= 0)) || (allowNegative && value === '-')) {
      if (maxValue && value > maxValue) {
        internalError = `Max value is ${maxValue}`;
      } else if (minValue && value < minValue) {
        internalError = `Min value is ${minValue}`;
      } else {
        internalError = internalError || additionalValidation ? additionalValidation(value) : '';
      }
      const dotIndex = value.indexOf('.');
      if (dotIndex !== -1) {
        value = value.slice(0, dotIndex + digitsAfterDot + (digitsAfterDot === 0 ? 0 : 1));
      }
      onChange(value, internalError);
      this.setState({internalError: internalError});
    }
  };

  stringInternalValidation = value => {
    const {onChange, maxLength, additionalValidation} = this.props;
    let internalError = '';

    if (maxLength && maxLength <= value.length) {
      internalError = `Max length is ${maxLength} characters`;
    }
    else {
      internalError = additionalValidation ? additionalValidation(value) : '';
    }
    onChange(value, internalError);
    this.setState({internalError: internalError});
  };

  onChange = ({target}) => {
    const {isNumeric} = this.props;
    let value = target.value;
    if (!isNumeric) {
      this.stringInternalValidation(value);
    }
    else {
      this.numericInternalValidation(value);
    }
  };

  render() {
    const {textAlign, placeholder, type, value, error, label, styles, onBlur, units} = this.props;
    const {internalError} = this.state;

    let currentError = typeof error === 'string' && error.length ? error : internalError || error;

    const classes = `${currentError ? 'error' : ''} ${units ? 'with-units' : ''}`;
    const errorTextElement = currentError ? <div className='ect-input-error'>{currentError}</div> : null;

    delete styles.textAlign;

    const unitsPosition = {
      [textAlign === 'center' && units ? 'left' : 'right']: textAlign === 'center' && units ? '52%' : 10
    };

    const textStyles = {
      textAlign: (textAlign === 'center' && units) ? 'right' : textAlign,
      paddingRight: (textAlign === 'center' && units) ? '50%' : 30
    };

    return (
      <div className={`ect-multi-input ${classes}`}>
        <label className={label.length ? '' : 'invisible'}>
          {label.length ? label : 'invisible text'}
        </label>
        <div className='ect-input-wrapper'>
          <input
            className={classes}
            type={type}
            style={{ ...textStyles, ...styles }}
            placeholder={placeholder}
            value={value}
            onBlur={onBlur}
            onChange={this.onChange}
            autoComplete='off'
          />
          {units ? (
            <span className={'units'} style={unitsPosition}>
              {units}
            </span>
          ) : null}
        </div>
        {errorTextElement}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/Input.jsx